import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import type { FeedbackIconProps, IconSize } from '../FeedbackIconTypes';

export interface ImageIconProps extends FeedbackIconProps {
  sourceImage: string;
}

const sizeMap: Record<IconSize, string> = {
  s: tokens.spacer.x2,
  m: tokens.spacer.x3,
  l: tokens.spacer.x4,
};

const ImageIconContainer = styled.div<ImageIconProps>`
  ${({ sourceImage }) => `background-image: url(${sourceImage});`}
  ${({ size = 's' }) => {
    const iconSize = size in sizeMap ? sizeMap[size as IconSize] : size;
    return `
    height: ${iconSize};
    width:  ${iconSize};
    background-size: ${iconSize} ${iconSize};
    `;
  }}
  flex-shrink: 0;
`;

export const ImageIcon = ({ description, ...props }: ImageIconProps): JSX.Element => {
  const hasDescription = description !== undefined && description.length > 0;
  return (
    <ImageIconContainer
      role={hasDescription ? 'img' : undefined}
      aria-label={description}
      aria-hidden={!hasDescription}
      {...props}
      data-testid="feedbackImageIcon"
    />
  );
};
